import { connect } from 'react-redux'
import { DraftUploadDialog } from '../../components/GenericProductConfig/DraftUploadDialog'
import * as actions from './actions.es6'

const mapStateToProps = state => ({
  draftFile: state.genericProducts.draftFile,
  uploadDocumentLoader: state.genericProducts.uploadDocumentLoader,
  uploadDocumentError: state.genericProducts.uploadDocumentError,
  pollDraftJobError: state.genericProducts.pollDraftJobError,
  draftJobId: state.genericProducts.draftJobId,
  draftPollAttempts: state.genericProducts.draftPollAttempts,
  draftResult: state.genericProducts.draftResult
})

const mapDispatchToProps = dispatch => ({
  onFileSelect: file => dispatch(actions.draftFileSelect(file)),
  onUpload: file => dispatch(actions.uploadDocumentRequest(file)),
  onPoll: jobId => dispatch(actions.pollDraftJobRequest(jobId)),
  onReset: () => dispatch(actions.resetDraftState())
})

export const DraftUploadDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftUploadDialog)
